import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getListManagerOfDepartmentSlice = createSlice({
  name: "getListManagerOfDepartment",
  initialState,
  reducers: {
    getListManagerOfDepartmentStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListManagerOfDepartmentSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListManagerOfDepartmentFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListManagerOfDepartment: () => {
      return { ...initialState };
    },
  },
});

export const {
  getListManagerOfDepartmentStart,
  getListManagerOfDepartmentSuccess,
  getListManagerOfDepartmentFailed,
  resetListManagerOfDepartment,
} = getListManagerOfDepartmentSlice.actions;

export default getListManagerOfDepartmentSlice.reducer;
